var map = {
	"./Post-Quantum Cryptography.png": 754,
	"./QuantumAI.png": 9707,
	"./QuantumCommunication.png": 5557,
	"./QuantumEducation.png": 315,
	"./QuantumMemory.png": 4724,
	"./QuantumSimulations.png": 9709
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8391;